import { useWalletAuth } from '@/hooks/useWalletAuth'
import { usePostHog } from 'posthog-js/react'
import { useCallback } from 'react'
import { Button, Checkbox, Link, Text, useToggle, View } from 'reshaped'
import { ZoraLogo } from '../ZoraLogo/ZoraLogo'
import styles from './Splash.module.css'
import { SplashVideo } from './SplashVideo'

export function Splash() {
  const { login } = useWalletAuth()
  const postHog = usePostHog()
  const { active: acceptedTerms, toggle: toggleAcceptedTerms } = useToggle(false)

  const handleConnectClick = useCallback(() => {
    postHog.capture('connect_wallet_click', {
      location: 'homepage',
      component: 'Splash',
    })

    login()
  }, [login, postHog])

  return (
    <View className={styles.app}>
      <View
        position="fixed"
        insetTop={0}
        insetBottom={0}
        insetStart={0}
        insetEnd={0}
        width="100vw"
        height="100vh"
        zIndex={1}
        attributes={{
          style: {
            pointerEvents: 'none',
          },
        }}
      >
        <SplashVideo />
      </View>

      <View className={styles.content}>
        <View
          className={styles.logo}
          justify="center"
          align="center"
          width="100%"
          maxWidth="100%"
        >
          <ZoraLogo />
        </View>
        <Button
          variant="solid"
          color="primary"
          size="xlarge"
          onClick={handleConnectClick}
          className={styles.cta}
          disabled={!acceptedTerms}
          attributes={{
            style: {
              border: '2px solid #D2D2D2',
              borderRadius: '12px',
              height: '60px',
              width: '388px',
              maxWidth: '100%',
              background: acceptedTerms
                ? 'linear-gradient(180deg, #0085FF 0%, #000AFF 50%, #0085FF 100%)'
                : '#CACACA',
              boxShadow:
                '-1.472px -1.472px 7.358px 0px #FFF inset, 1.472px 1.472px 7.358px 0px rgba(0, 0, 0, 0.10) inset, 0px 0px 2px 0px rgba(0, 0, 0, 0.30)',
            },
          }}
        >
          <Text
            variant="featured-3"
            weight="semibold"
            color={acceptedTerms ? 'white' : 'disabled'}
          >
            Connect
          </Text>
        </Button>

        <View direction="row" gap={2} align="center">
          <Checkbox name="terms" checked={acceptedTerms} onChange={toggleAcceptedTerms} />
          <View direction="row" gap={1} align="center">
            <Text color="primary">I agree to the</Text>
            <Link
              href="https://support.zora.co/en/articles/5638081"
              attributes={{
                target: '_blank',
                rel: 'noreferrer',
                style: {
                  textDecoration: 'none',
                },
              }}
            >
              <Text color="primary" weight="semibold">
                $ZORA terms and conditions
              </Text>
            </Link>
          </View>
        </View>
      </View>
    </View>
  )
}
